
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import {
  getMerchant,
  addMerchant,
  setMerchant,
  setMerchantEmail,
  setMerchantPsw,
  setMerchantPin,
  setChangeKey,
  setGoogleStatus,
  setAncestor
} from '@/api/merchant/merchant'
import { merchantBasicRules } from '@/utils/rules'
import { delObjEmptyKey } from '@/utils'
import { stringArrayToString, stringToStringArray } from '@/filters'
import { operationMessage } from '@/utils/message'
import { reqInterceptors } from '@/utils/interceptors'
import { checkNeedAudit } from '@/utils/permission'
import { AppModule } from '@/store/modules/app'
import { getEnterprise } from '@/api/universal'
import { getType } from '@/utils/cookies'
import { getAntAccountGroupList } from '@/api/product/antAccountGroup'

@Component({
  name: 'basicInformation',
  components: {}
})
export default class extends Vue {
  @Prop({ default: true }) isEdit!: boolean
  @Prop() merchant!: any

  get language() {
    return AppModule.language
  }
  private merchantList: any[] = []
  private status: any = null
  private infoForm: any = {
    name: null,
    email: null,
    password: null,
    phone: null,
    remarks: null,
    status: null,
    pin: null,
    ancestor_no: null,
    ancestor_name: null,
    notify_url: null,
    return_url: null,
    withdraw_notify_url: null,
    ip_address: [],
    key: null,
    description: null,
    google_auth_switch: true,
    send_email: true,
    login_password_changed: true,
    withdraw_password_changed: true,
    merchant_domain: null,
    checkout_counter_domain: null,
    extra_param: {
      allow_pass_notify_url: true,
      card_3d: '0',
      ant_product_account_group: '',
      proxies_with_hk: false,
      is_bank: '0'
    },
    currency_timezone_map: {}
  }
  private selectCurrency: any = ''
  private checkoutCounterDomain: any = ''
  private rules = merchantBasicRules
  private loading = false
  private dialogVisible: boolean = false
  private dialogText: string = ''
  private needSetKey: string = ''

  private merchantDomain: any[] = []
  private checkoutDomains: any[] = []
  private availableCurrency: any[] = []
  private ip_address: string = ''

  private antGroup: any[] = []

  private changeInput(e: any) {
    e.target.value = e.target.value.replace(
      /[`~!@#$%^&*()_\-+=<>?"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,
      ''
    )
  }
  private ipInput(v: any) {
    v = v.replace(
      /[`~!@#$%^&*()_\-+=<>?"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,
      ''
    )
  }

  // 编辑IP地址相关操作
  private openIpEdit: boolean = false
  private editIpAddress() {
    this.openIpEdit = true
  }
  private onAdd() {
    this.infoForm.ip_address.push('')
  }
  private onDel(i) {
    this.infoForm.ip_address.splice(i, 1)
  }
  private editIp() {
    this.infoForm.ip_address = this.infoForm.ip_address.filter(item => {
      return item !== ''
    })
    this.openIpEdit = false
  }
  @Watch('infoForm.ip_address')
  private watchIp(i) {
    this.ip_address = stringArrayToString(i)
  }

  private ipAddressChange(e: any) {
    this.infoForm.ip_address = stringToStringArray(e)
  }

  private enterpriseId: any = null
  private async getEnterprise() {
    await getEnterprise().then((res: any) => {
      this.enterpriseId = res.id
      this.merchantDomain = res.merchant_domains
      this.checkoutDomains = res.checkout_counter_domains
    })
  }

  // 获取蚂蚁账户组列表
  private async getAntAccountGroupList() {
    await getAntAccountGroupList().then((res: any) => {
      this.antGroup = res.results
    })
  }

  // 是否需要审核
  get isNeedAudit() {
    let authCode = ''
    switch (this.needSetKey) {
      case 'email':
        authCode = 'change_merchant_email'
        break
      case 'password':
        authCode = 'change_merchant_password'
        break
      case 'pin':
        authCode = 'change_merchant_pin'
        break
      case 'key':
        authCode = 'change_merchant_key'
        break
      case 'ancestor_no':
        authCode = 'change_merchant_ancestor'
      default:
        break
    }
    return checkNeedAudit(authCode) !== undefined
  }

  private changeGoogleStatus() {
    const ops: any = {
      title: this.$t('manager.taskDescription'),
      key: 'description',
      fn: this.setGoogleStatus,
      params: {
        merchant_no: this.merchant.merchant_no,
        google_auth_switch: this.infoForm.google_auth_switch
      },
      authCode: 'change_merchant_google_auth'
    }
    reqInterceptors(ops)
    this.infoForm.google_auth_switch = !this.infoForm.google_auth_switch
  }

  private async setGoogleStatus(data) {
    await setGoogleStatus(data).then(() => {
      operationMessage(
        checkNeedAudit('change_merchant_google_auth') !== undefined
      )
    })
  }

  private closeDialog() {
    this.needSetKey = ''
    this.getMerchantInfo()
  }

  private openDialog(text: string, key: string) {
    if (this.language === 'en') {
      this.dialogText = 'Modify ' + text + '：'
    }
    if (this.language === 'zh_cn') {
      this.dialogText = '修改 ' + text + '：'
    }
    if (this.language === 'zh_tw') {
      this.dialogText = '修改 ' + text + '：'
    }
    this.needSetKey = key
    if (key === 'ancestor_no') {
      this.getMerchantList(true)
    }
    this.dialogVisible = true
  }

  private back() {
    this.$emit('close')
  }

  private createMerchant() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data = {
            ...this.infoForm,
            status: this.status
          }
          delObjEmptyKey(data)
          if (!this.isEdit) {
            // 创建商户
            await addMerchant(data).then((res: any) => {
              this.$message({
                message: 'Create successful!',
                type: 'success'
              })
              this.$emit('next')
            })
            this.loading = false
          }
        } catch (e) {
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  private save() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data = {
            ...this.infoForm,
            ip_address: this.infoForm.ip_address,
            status: this.status,
            allow_pass_notify_url: this.infoForm.allow_pass_notify_url,
            card_3d: this.infoForm.card_3d,
            proxies_with_hk: this.infoForm.proxies_with_hk,
            is_bank: this.infoForm.is_bank
          }

          if (this.isEdit) {
            // 修改商户
            const ops: any = {
              title: 'Task Description',
              key: 'description',
              fn: this.setMerchant,
              params: data,
              authCode: 'change_merchant'
            }
            reqInterceptors(ops)
            this.loading = false
          }
          this.loading = false
        } catch (e) {
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  private async setMerchant(data) {
    delete data.email
    delete data.key
    delete data.logo
    delete data.password
    delete data.pin
    delete data.ancestor_name
    delete data.ancestor_no
    delete data.currency_timezone_map
    try {
      await setMerchant(data).then((res: any) => {
        operationMessage(true)
        this.getMerchantInfo()
        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  // 修改商户其他信息
  private async update() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        const data: any = {
          merchant_no: this.infoForm.merchant_no,
          [this.needSetKey]: this.infoForm[this.needSetKey],
          description: this.infoForm.description
        }
        this.loading = true
        try {
          switch (this.needSetKey) {
            case 'email':
              await setMerchantEmail(data).then((res: any) => {
                operationMessage(
                  checkNeedAudit('change_merchant_email') !== undefined
                )
                this.infoForm.email = res.email ? res.email : 'Await audit'
                this.loading = false
              })
              break
            case 'password':
              await setMerchantPsw(data).then((res: any) => {
                operationMessage(
                  checkNeedAudit('change_merchant_password') !== undefined
                )
                this.loading = false
              })
              break
            case 'pin':
              await setMerchantPin(data).then((res: any) => {
                operationMessage(
                  checkNeedAudit('change_merchant_pin') !== undefined
                )
                this.infoForm.pin = ''
                this.loading = false
              })
              break
            case 'key':
              await setChangeKey(data).then((res: any) => {
                operationMessage(
                  checkNeedAudit('change_merchant_key') !== undefined
                )
                this.infoForm.key = ''
                this.loading = false
              })
              break
            case 'ancestor_no':
              await setAncestor(data).then((res: any) => {
                operationMessage(
                  checkNeedAudit('change_merchant_ancestor') !== undefined
                )
                this.loading = false
              })
          }
          this.infoForm.description = ''
        } catch (e) {
          this.infoForm.description = ''
          this.needSetKey !== 'email' && (this.infoForm[this.needSetKey] = '')
          this.loading = false
        }
        this.dialogVisible = false
      } else {
        return false
      }
    })
  }

  // 获取商户列表
  private async getMerchantList(isFilter?: boolean) {
    const data: any = {
      page: 1,
      page_size: 100
    }
    await getMerchant(data).then((res: any) => {
      if (isFilter) {
        this.merchantList = res.results.filter((item: any) => {
          return item.merchant_no !== this.infoForm.merchant_no
        })
      } else {
        this.merchantList = res.results
      }
    })
  }

  // 获取商户列表
  private async getMerchantListSearch(query: string) {
    const data: any = {
      name: query,
      page: 1,
      page_size: 100
    }
    await getMerchant(data).then((res: any) => {
      this.merchantList = res.results.filter((item: any) => {
        return item.merchant_no !== this.infoForm.merchant_no
      })
    })
  }

  // 获取商户信息
  private async getMerchantInfo() {
    await getMerchant({ merchant_no: this.merchant.merchant_no }).then(
      (res: any) => {
        if (res.results.length > 0) {
          Object.assign(this.infoForm, res.results[0])
          this.status = this.infoForm.status + ''
          if (this.infoForm.extra_param.card_3d) {
            if (
              this.infoForm.extra_param.card_3d === '1' ||
              this.infoForm.extra_param.card_3d === 1
            ) {
              this.infoForm.extra_param.card_3d = '1'
            } else {
              this.infoForm.extra_param.card_3d = '0'
            }
          } else {
            this.infoForm.extra_param.card_3d = '0'
          }
          if (this.infoForm.extra_param.card_config) {
            this.cardForm = this.infoForm.extra_param.card_config
          }
          this.antGroup = this.infoForm.extra_param.ant_group
          this.availableCurrency = this.infoForm.available_currency
        }
      }
    )
  }

  // 打开设置时区弹窗
  private openCurrencyTimeZone: boolean = false
  private changeCurrency(e) {
    // e 是选择的当前货币
    this.openCurrencyTimeZone = true
  }

  // 关闭设置时区弹窗
  private closeCurrencyTimeZone() {
    this.infoForm.description = ''
    this.openCurrencyTimeZone = false
  }

  private confirm() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data: any = {
            merchant_no: this.infoForm.merchant_no,
            currency_timezone_map: this.infoForm.currency_timezone_map,
            description: this.infoForm.description
          }
          await setMerchant(data).then((res: any) => {
            operationMessage(true)
            this.getMerchantInfo()
            this.closeCurrencyTimeZone()
            this.loading = false
          })
        } catch (e) {
          this.closeCurrencyTimeZone()
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  private cardForm: any = {
    period: '',
    count: '',
    type: '1'
  }
  private cardRules: any = {
    period: [
      { required: true, message: 'Please input period', trigger: 'blur' }
    ],
    count: [{ required: true, message: 'Please input count', trigger: 'blur' }],
    type: [
      {
        required: true,
        message: 'Please enter the type',
        trigger: 'change'
      }
    ]
  }
  private cardDialog: boolean = false
  private openCardDialog() {
    this.cardDialog = true
  }
  private closeCard() {
    this.cardDialog = false
  }
  private async cardConfirm() {
    ;(this.$refs.cardForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          const data = {
            ...this.infoForm,
            ip_address: this.infoForm.ip_address,
            status: this.status,
            allow_pass_notify_url: this.infoForm.allow_pass_notify_url,
            proxies_with_hk: this.infoForm.proxies_with_hk,
            is_bank: this.infoForm.is_bank,
            extra_param: {
              card_config: {
                ...this.cardForm
              }
            }
          }
          // 修改商户
          const ops: any = {
            title: 'Task Description',
            key: 'description',
            fn: this.setMerchant,
            params: data,
            authCode: 'change_merchant'
          }
          reqInterceptors(ops)
          this.loading = false
          this.closeCard()
          // await setMerchant(newData).then((res: any) => {
          //   this.$message.success('Successful operation!')
          //   this.getMerchantInfo()
          //   this.closeCard()
          //   this.loading = false
          // })
        } catch (e) {
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  // 时区
  private timeZone = AppModule.constant['TIMEZONE_MAP']
  private timeZoneList: any[] = []
  private getTimeZoneList() {
    this.timeZoneList = Object.keys(this.timeZone).map(v => {
      return { value: this.timeZone[v], label: v }
    })
  }
  private sysType: any = ''
  mounted() {
    this.sysType = getType()
    this.getEnterprise()
    // this.getAntAccountGroupList()
    this.getTimeZoneList()
    this.ip_address = stringArrayToString(this.infoForm.ip_address)
    if (this.isEdit && this.merchant) {
      this.getMerchantInfo()
    } else if (!this.isEdit) {
      this.getMerchantList()
    }
  }
}
